import { createSlice } from "@reduxjs/toolkit";
import {
  getContainers,
  getContainersGetFilters,
  getContainersGetFiltersExport,
  getContainerByID,
  getContainersStats,
  getContainersGenStats,
  getContainersFilterAll,
  getContainersFilter,
  addNewContainer,
  updateContainer,
  deleteContainer,
  addNewContainerGetFilters,
  updateContainerGetFilters,
  deleteContainerGetFilters,
  getBWarehouses,
} from "./thunk";

export const initialState = {
  containers: [],
  containersGetFilters: [],
  containersGetFiltersExport: [],
  containersStats: [],
  containersGenStats: [],
  containerSpecial: [],
  containersFilterAll: [],
  containersFilter: [],
  bwarehouses: [],
  isLoading: false,
  isBWarehousesLoading: false,
  error: null,
  isContainersSuccess: false,
  isBWarehousesSuccess: false,
  isContainersGetFiltersSuccess: false,
  isContainersGetFiltersFailed: false,
  isContainersGetFiltersExportSuccess: false,
  isContainersGetFiltersExporFailed: false,
  isLoadingGetFilters: false,
  isLoadingGetFiltersExport: false,
  isContainersFailed: false,
  isBWarehousesFailed: false,
  isContainersStatsSuccess: false,
  isContainersStatsFail: false,
  isContainersGenStatsSuccess: false,
  isContainersGenStatsFail: false,
  isContainerSpecialSuccess: false,
  isContainerSpecialFail: false,
  isContainersFilterAllSuccess: false,
  isContainersFilterAllFailed: false,
  isContainersFilterSuccess: false,
  isContainersFilterFailed: false,
  isContainerAdd: false,
  isContainerAddFail: false,
  isContainerUpdate: false,
  isContainerUpdateFail: false,
  isContainerDelete: false,
  isContainerDeleteFail: false,
};

const containersSlice = createSlice({
  name: "container",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getContainers.fulfilled, (state, action) => {
      if (action.payload && Array.isArray(action.payload)) {
        state.containers = action.payload;
      } else {
        console.warn("Invalid payload format:", action.payload);
      }
      state.isContainersFailed = false;
      state.isContainersSuccess = true;
    });

    builder.addCase(getContainers.rejected, (state, action) => {
      state.error =
        action.payload?.error ||
        action.error?.message ||
        "An unknown error occurred.";
      state.isContainersFailed = true;
      state.isContainersSuccess = false;
      state.isLoading = false;
    });

    builder.addCase(getBWarehouses.fulfilled, (state, action) => {
      if (action.payload && Array.isArray(action.payload)) {
        state.bwarehouses = action.payload;
      } else {
        console.warn("Invalid payload format:", action.payload);
      }
      state.isBWarehousesFailed = false;
      state.isBWarehousesSuccess = true;
    });

    builder.addCase(getBWarehouses.rejected, (state, action) => {
      state.error =
        action.payload?.error ||
        action.error?.message ||
        "An unknown error occurred.";
      state.isBWarehousesFailed = true;
      state.isBWarehousesSuccess = false;
      state.isBWarehousesLoading = false;
    });

    builder
      .addCase(getContainersGetFilters.pending, (state) => {
        state.isLoadingGetFilters = true;
        state.isContainersGetFiltersFailed = false;
        state.isContainersGetFiltersSuccess = false;
        state.error = null;
      })

      .addCase(getContainersGetFilters.fulfilled, (state, action) => {
        const {
          containers = [],
          totalStatusCounts = {},
          totalCount = 0,
          countsPerDate = {},
        } = action.payload || {};

        state.containersGetFilters = containers;
        state.totalStatusCounts = totalStatusCounts;
        state.totalCount = totalCount;
        state.countsPerDate = countsPerDate;

        state.isLoadingGetFilters = false;
        state.isContainersGetFiltersFailed = false;
        state.isContainersGetFiltersSuccess = true;
        state.error = null;
      })

      .addCase(getContainersGetFilters.rejected, (state, action) => {
        state.error =
          (typeof action.payload === "string" ? action.payload : action.payload?.error) ??
          action.error?.message ??
          "Өгөгдөл татахад алдаа гарлаа";
        state.isLoadingGetFilters = false;
        state.isContainersGetFiltersFailed = true;
        state.isContainersGetFiltersSuccess = false;
      });

    builder
      .addCase(getContainersGetFiltersExport.pending, (state) => {
        state.isLoadingGetFiltersExport = true;
        state.isContainersGetFiltersExportFailed = false;
        state.isContainersGetFiltersExportSuccess = false;
        state.error = null;
      })

      .addCase(getContainersGetFiltersExport.fulfilled, (state, action) => {
        const { containers = [], totalCount = 0 } = action.payload || {};

        state.containersGetFiltersExport = containers;
        state.totalCount = totalCount;

        state.isLoadingGetFiltersExport = false;
        state.isContainersGetFiltersExportFailed = false;
        state.isContainersGetFiltersExportSuccess = true;
        state.error = null;
      })

      .addCase(getContainersGetFiltersExport.rejected, (state, action) => {
        state.error =
          (typeof action.payload === "string" ? action.payload : action.payload?.error) ??
          action.error?.message ??
          "Өгөгдөл татахад алдаа гарлаа";
        state.isLoadingGetFiltersExport = false;
        state.isContainersGetFiltersExportFailed = true;
        state.isContainersGetFiltersExportSuccess = false;
      });

    // builder.addCase(getContainerByID.fulfilled, (state, action) => {
    //   if (action.payload && typeof action.payload === "object") {
    //     state.container = action.payload; // singular container
    //   } else {
    //     console.warn("Invalid payload format:", action.payload);
    //     state.container = null;
    //   }
    //   state.isContainersFailed = false;
    //   state.isContainersSuccess = true;
    // });

    builder.addCase(getContainerByID.fulfilled, (state, action) => {
      state.containerSpecial = action.payload;
      state.isContainerSpecialFail = false;
      state.isContainerSpecialSuccess = true;
    });

    builder.addCase(getContainerByID.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isContainerSpecialFail = true;
      state.isContainerSpecialSuccess = false;
    });

    builder.addCase(getContainersStats.fulfilled, (state, action) => {
      state.containersStats = action.payload;
      state.isContainersStatsFail = false;
      state.isContainersStatsSuccess = true;
    });

    builder.addCase(getContainersStats.rejected, (state, action) => {
      state.error = action.payload?.error || action.error?.message || null;
      state.isContainersStatsFail = true;
      state.isContainersStatsSuccess = false;
    });

    builder.addCase(getContainersGenStats.fulfilled, (state, action) => {
      state.containersGenStats = action.payload;
      state.isContainersGenStatsFail = false;
      state.isContainersGenStatsSuccess = true;
    });

    builder.addCase(getContainersGenStats.rejected, (state, action) => {
      state.error = action.payload?.error || action.error?.message || null;
      state.isContainersGenStatsFail = true;
      state.isContainersGenStatsSuccess = false;
    });

    builder.addCase(getContainersFilterAll.fulfilled, (state, action) => {
      state.containersFilterAll = action.payload;
      state.isContainersFilterAllFailed = false;
      state.isContainersFilterAllSuccess = true;
      state.isLoading = false;
    });

    builder.addCase(getContainersFilterAll.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message;
      state.isContainersFilterAllFailed = true;
      state.isContainersFilterAllSuccess = false;
      state.isLoading = false;
    });

    builder.addCase(getContainersFilter.fulfilled, (state, action) => {
      state.containersFilter = action.payload;
      state.isContainersFilterFailed = false;
      state.isContainersFilterSuccess = true;
      state.isLoading = false;
    });

    builder.addCase(getContainersFilter.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message;
      state.isContainersFilterFailed = true;
      state.isContainersFilterSuccess = false;
      state.isLoading = false;
    });

    builder.addCase(addNewContainer.fulfilled, (state, action) => {
      state.containers.push(action.payload);
      state.isContainerAdd = true;
      state.isContainerAddFail = false;
    });

    builder.addCase(addNewContainer.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message;
      state.isContainerAdd = false;
      state.isContainerAddFail = true;
    });

    builder.addCase(updateContainer.fulfilled, (state, action) => {
      state.containers = state.containers.map((container) =>
        container._id.toString() === action.payload._id.toString()
          ? { ...container, ...action.payload }
          : container
      );
      state.isContainerUpdate = true;
      state.isContainerUpdateFail = false;
    });

    builder.addCase(updateContainer.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message;
      state.isContainerUpdate = false;
      state.isContainerUpdateFail = true;
    });

    builder.addCase(deleteContainer.fulfilled, (state, action) => {
      state.containers = state.containers.filter(
        (container) =>
          container._id.toString() !== action.payload.container.toString()
      );
      state.isContainerDelete = true;
      state.isContainerDeleteFail = false;
    });

    builder.addCase(deleteContainer.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message;
      state.isContainerDelete = false;
      state.isContainerDeleteFail = true;
    });

    //===================== NEW ==========================================

    builder.addCase(addNewContainerGetFilters.fulfilled, (state, action) => {
      state.containersGetFilters.push(action.payload);
      state.isContainerAdd = true;
      state.isContainerAddFail = false;
    });

    builder.addCase(addNewContainerGetFilters.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message;
      state.isContainerAdd = false;
      state.isContainerAddFail = true;
    });

    builder.addCase(updateContainerGetFilters.fulfilled, (state, action) => {
      state.containersGetFilters = state.containersGetFilters.map((container) =>
        container._id === action.payload._id
          ? { ...container, ...action.payload }
          : container
      );
    });

    builder.addCase(updateContainerGetFilters.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message;
      state.isContainerUpdate = false;
      state.isContainerUpdateFail = true;
    });

    builder.addCase(deleteContainerGetFilters.fulfilled, (state, action) => {
      state.containersGetFilters = state.containersGetFilters.filter(
        (container) =>
          container._id.toString() !== action.payload.container.toString()
      );
      state.isContainerDelete = true;
      state.isContainerDeleteFail = false;
    });

    builder.addCase(deleteContainerGetFilters.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message;
      state.isContainerDelete = false;
      state.isContainerDeleteFail = true;
    });
  },
});

export default containersSlice.reducer;
